import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-4 pb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_AuditCardCols = _resolveComponent("AuditCardCols")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_expand_transition = _resolveComponent("v-expand-transition")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "my-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "px-6"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cardCols, (col, colIndex) => {
            return (_openBlock(), _createBlock(_component_v_col, {
              key: `col-${colIndex}`,
              cols: col.cols,
              style: {"align-content":"center"},
              class: _normalizeClass(_ctx.dynamicClass(_ctx.cardCols, false, 1, 1, col))
            }, {
              default: _withCtx(() => [
                (col.nestedRows)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(col.nestedRows, (nestedRow, rowIndex) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: `row-${rowIndex}`
                      }, [
                        _createVNode(_component_v_row, { "no-gutters": "" }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(nestedRow.nestedCols, (nestedCol, nestedColIndex) => {
                              return (_openBlock(), _createBlock(_component_v_col, {
                                key: `nestedCol-${nestedColIndex}`,
                                cols: nestedCol.cols,
                                style: {"align-content":"center"},
                                class: _normalizeClass(
                                    _ctx.dynamicClass(
                                        nestedRow.nestedCols,
                                        true,
                                        rowIndex,
                                        col.nestedRows.length,
                                        nestedCol,
                                    )
                                )
                              }, {
                                default: _withCtx(() => [
                                  (nestedCol.component === 'v-tooltip')
                                    ? (_openBlock(), _createBlock(_component_v_tooltip, _mergeProps({
                                        key: 0,
                                        location: "bottom",
                                        ref_for: true
                                      }, nestedCol.props), {
                                        activator: _withCtx(({ props }) => [
                                          _createVNode(_component_v_btn_icon, _mergeProps({ ref_for: true }, props, {
                                            size: "large",
                                            class: "ml-2",
                                            icon: "$oss-help",
                                            color: nestedCol.props.color || undefined
                                          }), null, 16, ["color"])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_AuditCardCols, { col: nestedCol }, null, 8, ["col"])
                                        ]),
                                        _: 2
                                      }, 1040))
                                    : (_openBlock(), _createBlock(_resolveDynamicComponent(nestedCol.component), _mergeProps({
                                        key: 1,
                                        ref_for: true
                                      }, nestedCol.props), {
                                        default: _withCtx(() => [
                                          _createVNode(_component_AuditCardCols, { col: nestedCol }, null, 8, ["col"])
                                        ]),
                                        _: 2
                                      }, 1040))
                                ]),
                                _: 2
                              }, 1032, ["cols", "class"]))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                    }), 128))
                  : (_openBlock(), _createBlock(_resolveDynamicComponent(col.component), _mergeProps({
                      key: 1,
                      ref_for: true
                    }, col.props), {
                      default: _withCtx(() => [
                        _createVNode(_component_AuditCardCols, { col: col }, null, 8, ["col"])
                      ]),
                      _: 2
                    }, 1040))
              ]),
              _: 2
            }, 1032, ["cols", "class"]))
          }), 128)),
          _createVNode(_component_v_col, {
            cols: "1",
            class: "d-flex align-center px-0 justify-center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "align-center pa-0"
                  }, {
                    default: _withCtx(() => [
                      (_ctx.validated)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 0,
                            class: "px-2 pt-1",
                            color: "primary"
                          }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                              _createTextVNode(" $check_circle ")
                            ])),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "6",
                    class: "align-center pa-0"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn_icon, {
                        icon: _ctx.expanded ? '$fa-chevron-up' : '$fa-chevron-down',
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expanded = !_ctx.expanded)),
                        style: {"width":"40px"},
                        color: "secondary",
                        class: "d-inline px-2"
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_expand_transition, null, {
        default: _withCtx(() => [
          (_ctx.expanded)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "{{expandContent}}", {}, undefined, true)
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}